<template>
  <!--   <div v-click-outside="onClickOutside">-->
  <div v-click-outside="onClickOutside" style="height: 100px">
    <span v-show="status == false" class="text-edit" @click="edit()">{{ input }}</span>

    <div v-if="status == true" class="input-group">
      <input v-if="type == 'text'" v-model="input" :type="type" class="form-control" @keydown.enter="save()">

      <div class="input-group-append">
        <button class="btn btn-outline-secondary" type="button" @click="save()">
          <i class="dripicons-checkmark text-primary" />
        </button>
        <button class="btn btn-outline-secondary" type="button" @click="cancel()">
          <i class="dripicons-cross text-secondary" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "EditAble",
    props: {
      value: { default: '' },
      type: { type: String, default: 'text' },
      min: { default: 0 },
      max: { default: 100 }
    },
    data: function () {
      return {
        input: '',
        old: '',
        status: false,
        vcoConfig: {
          events: ['dblclick', 'click']
        }

      }
    },
    watch: {
      'value': function (val) {
        this.input = val
      }
    },
    mounted: function () {
      //    console.log(this.value)
      this.input = this.value
      if (this.type == 'text') {
        this.input = 'Click to edit'
      }
    },
    methods: {
      onClickOutside() {
        /*event, el*/
        console.log('edit')

       // this.save();
        this.cancel()
      },
      save: function () {
        //  console.log('save:' + this.input)
        if (this.status == false) return
        let val = this.input
        if (val == 'Click to edit') {
          val = ''
        }
        if (this.input != this.old) {
          this.$emit('input', val)
          this.$emit('change', val)
          this.old = this.input;
        }
        this.status = false
      },
      edit: function () {
        this.status = true;
        if (this.input == 'Click to edit') {
          this.input = ''
        }
        console.log('text')
      },
      cancel: function () {
        this.status = false;
        if (this.input == '') {
          this.input = 'Click to edit'
        }
      }
    }
  }
</script>

<style scoped lang="scss">

</style>